<template>

  <v-simple-table class="stickyTable">
    <template v-slot:default>
      <thead>
        <tr :class="{'secondary':min,'primary':!min}">
          <th :class="{'secondary':min,'primary':!min}">Years Left</th>
          <th :class="{'secondary':min,'primary':!min}">Pay Off Date</th>
          <th :class="{'secondary':min,'primary':!min}">{{ min ? 'Payments Left' : 'Payment Ratio'}}</th>
          <th :class="{'secondary':min,'primary':!min}">Debt / Liability</th>
          <th :class="{'secondary':min,'primary':!min}">% Rate</th>
          <th :class="{'secondary':min,'primary':!min}" v-if="min">Current Balance</th>
          <th :class="{'secondary':min,'primary':!min}">Monthly Payment</th>
          <th :class="{'secondary':min,'primary':!min}" v-if="!min">Payoff</th>
          <th :class="{'secondary':min,'primary':!min}">Interest Payments</th>
          <th :class="{'secondary':min,'primary':!min}" v-if="min">Total Owed</th>
          <th :class="{'secondary':min,'primary':!min}" v-else>Saved Interest</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="debt in debtsSorted"
          :key="'table-debt-' + id + '-' + debt.id"
          @click="$emit('on-open-debt', debt)"
          style="cursor: pointer;"
        > 
          <td class="text-center">
            {{ Math.round( debtMonthsTillPayoff(debt) / 12 * 10) / 10 }}
          </td>
          <td class="text-center">
            {{ $moment(debtEndDate(debt)).format('MM/YYYY') }}
          </td>
          
          <td class="text-center" v-if="min">
            {{ debtMonthsTillPayoff(debt) }}
          </td>
          <td class="text-center" v-else>
            {{ debt.plan_months_till_payoff }} / {{ debt.months_till_payoff }}
          </td>

          <td>
            {{ debt.name }}
          </td>
          <td>
            {{ debt.interest_rate }}%
          </td>
          <td class="currency" v-if="min">
            {{ debt.balance | number }}
          </td>
          <td class="currency">
            {{ debt.minimum_payment | number }}
          </td>
          <td class="currency" v-if="!min">
            {{ debt.plan_payoff | number }}
          </td>
          <td class="currency">
            {{ (min ? debt.interest_balance : debt.plan_interest_balance) | number }}
          </td>
          <td class="currency" v-if="min">
            {{ (parseFloat(debt.interest_balance) + parseFloat(debt.balance)) | number }}
          </td>
          <td class="currency" v-else>
            {{ (parseFloat(debt.interest_balance) - parseFloat(debt.plan_interest_balance)) | number }}
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr :class="{'secondary':min,'primary':!min}">
          <td colspan="5" :class="{'secondary':min,'primary':!min}">
            Totals
          </td>
          <td v-if="min" class="currency" :class="{'secondary':min,'primary':!min}">
            {{ totals.balance | number }}
          </td>
          <td class="currency" :class="{'secondary':min,'primary':!min}">
            {{ totals.monthly_payment | number }}
          </td>
          <td v-if="!min" class="currency" :class="{'secondary':min,'primary':!min}">
            {{ totals.payoff | number }}
          </td>
          <td class="currency" :class="{'secondary':min,'primary':!min}">
            {{ totals.interest_payment | number }}
          </td>
          <td v-if="min" class="currency" :class="{'secondary':min,'primary':!min}">
            {{ totals.total_owed | number }}
          </td>
          <td v-else class="currency" :class="{'secondary':min,'primary':!min}">
            {{ totals.interest_saved | number }}
          </td>
        </tr>
      </tfoot>
    </template>
  </v-simple-table>

</template>

<script>
export default {
  name: 'DebtTable',
  props: {
    plan: {
      type: Object,
      required: true
    },
    min: Boolean
  },
  data() {
    return {
      id: null
    }
  },
  mounted() {
    this.id = this._uid
  },
  computed: {
    debtsSorted() {
      let ref = this
      let arr = []

      for(let i = 0; i < Object.keys(this.plan.data.debts).length; i++) {
        let key = Object.keys(this.plan.data.debts)[i];
        arr.push(this.plan.data.debts[key]);
      }
      return arr.sort( function(a, b) {
        if(ref.min) {
          return a.months_till_payoff - b.months_till_payoff
        } else {
          return a.plan_months_till_payoff - b.plan_months_till_payoff
        }
      })
    },
    totals() {
      let ref = this
      let data = {
        balance: 0,
        monthly_payment: 0,
        interest_payment: 0,
        payoff: 0,
        interest_saved: 0,
        total_owed: 0
      }
      this.debtsSorted.forEach(debt => {
        if(ref.min) {
          data.balance              += parseFloat(debt.balance)
          data.interest_payment     += parseFloat(debt.interest_balance)
          data.total_owed           += (parseFloat(debt.interest_balance) + parseFloat(debt.balance))
        } else {
          data.payoff               += (0)
          data.interest_payment     += parseFloat(debt.plan_interest_balance)
          data.interest_saved       += (parseFloat(debt.interest_balance) - parseFloat(debt.plan_interest_balance))
        }
        data.monthly_payment    += parseFloat(debt.minimum_payment)
      })
      Object.keys(data).forEach(k => {
        data[k] = Math.round(data[k] * 100, 2) / 100
      })
      return data
    }
  },
  methods: {
    debtMonthsTillPayoff(debt) {
      return (this.min ? debt.months_till_payoff : debt.plan_months_till_payoff)
    },
    debtEndDate(debt) {
      return (this.min ? debt.end_date : debt.plan_end_date)
    }
  }
}
</script>

<style lang="scss" scoped>
  .stickyTable {
    ::v-deep thead > tr > th {
      font-size: 12px !important;
      color: #FFF !important;
      line-height: 14px !important;
      height: 40px !important;
    }
    ::v-deep tbody > tr > td {
      font-size: 12px !important;
      height: 30px !important;
    }
    ::v-deep tfoot > tr > td {
      font-size: 12px !important;
      font-weight: bold !important;
      color: #FFF;
      height: 40px !important;
    }
  }
</style>